import { Controller } from "@hotwired/stimulus"

// Captain/commander-only trigger for an ad-hoc portfolio snapshot. POSTs
// to companies#take_portfolio_snapshot (sync capture) and shows a toast.
export default class extends Controller {
  static values = { url: String }

  async capture(event) {
    const btn = event.currentTarget
    if (btn.disabled) return

    btn.disabled = true
    const originalTitle = btn.getAttribute("title")
    btn.setAttribute("title", "Capturing…")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          Accept: "application/json"
        }
      })
      const data = await response.json().catch(() => ({}))

      if (!response.ok || !data.success) {
        const msg = (data.errors && data.errors.join(", ")) || "Snapshot failed"
        this._showToast(msg, "alert")
        return
      }

      const count = data.snapshot?.project_count ?? 0
      this._showToast(`Snapshot captured · ${count} project${count === 1 ? "" : "s"}`, "notice")
      this._reloadDashboardFrame()
    } catch (err) {
      this._showToast(err.message || "Network error", "alert")
    } finally {
      btn.disabled = false
      btn.setAttribute("title", originalTitle || "Take portfolio snapshot now")
    }
  }

  _showToast(message, type = "notice") {
    const toast = document.createElement("div")
    toast.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    toast.setAttribute("data-controller", "flash")
    toast.setAttribute("data-flash-dismiss-after-value", "5000")
    toast.textContent = message
    document.body.prepend(toast)
  }

  // Refresh the dashboard content frame in place so the new snapshot's
  // insights, "last updated" timestamp, and AI Pulse pick up fresh data
  // without a full-page reload.
  _reloadDashboardFrame() {
    const frame = document.getElementById("portfolio-dashboard-content")
    if (!frame) return
    frame.setAttribute("src", window.location.pathname + window.location.search)
  }
}
